var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M7 4.55c-.709 0-1.283.575-1.283 1.283v16.334c0 .708.574 1.283 1.283 1.283h4.667c.58 0 1.05.47 1.05 1.05 0 .58-.47 1.05-1.05 1.05H7c-1.869 0-3.383-1.515-3.383-3.383V5.833C3.617 3.965 5.13 2.45 7 2.45h4.667c.58 0 1.05.47 1.05 1.05 0 .58-.47 1.05-1.05 1.05H7zM19.09 7.424c.41-.41 1.076-.41 1.486 0l5.833 5.833c.41.41.41 1.075 0 1.485l-5.833 5.834c-.41.41-1.075.41-1.485 0-.41-.41-.41-1.075 0-1.485L24.18 14l-5.09-5.09c-.41-.41-.41-1.076 0-1.486z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M10.617 14c0-.58.47-1.05 1.05-1.05h14c.58 0 1.05.47 1.05 1.05 0 .58-.47 1.05-1.05 1.05h-14c-.58 0-1.05-.47-1.05-1.05z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSignout);
export default __webpack_public_path__ + "static/media/account-signout.56adcb5a2ce63420ead3309a2b819f7d.svg";
export { ForwardRef as ReactComponent };